<template>
  <div>
    <div class="row">
      <div class="col-11">
        <SectionTitle
          icon="fas fa-info-circle"
          content="Movilidad"
          container-class="tag-badge mt-5 mb-4"
        />
      </div>
      <div
        v-if="canDelete && !disabled"
        class="col-1 d-flex justify-content-end align-items-center"
      >
        <action-button
          i="far fa-times pointer icon-right color-primary-3 font-28"
          class="px-1 mr-2 "
          @click="$emit('delete')"
        />
      </div>
    </div>

    <div class="d-flex flex-column">
      <div class="question-element mt-2">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante tiene un impedimento ortopédico que limita su
              ambulación (su caminar).
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable ? 'required' : ''"
            >
              <CustomRadioBorder
                id="rgMobilityStudentHasImpediment"
                v-model="value.hasImpediment"
                :change-event="onHasImpedimentChange"
                name="studentHasImpediment"
                label=""
                is-question-list
                :options="hasImpedimentOptions"
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div v-if="value.hasImpediment" class="mt-2 mb-4">
        <validation-provider
          immediate
          v-slot="{ errors }"
          :rules="validable ? 'required' : ''"
        >
          <custom-radio
            v-model="value.isImpedimentPermanent"
            :change-event="onIsImpedimentPermanentChange"
            :options="isImpedimentPermanentOptions"
            is-inline
            class="radio-button-container"
            custom-error-msg="Favor de seleccionar una alternativa."
            :error="Boolean(errors[0])"
            :is-disabled="disabled"
          />
        </validation-provider>
      </div>

      <div class="question-element mt-2">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante utiliza un equipo para moverse de un lugar a otro
              que require asistencia de un recurso humano.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable ? 'required' : ''"
            >
              <CustomRadioBorder
                id="rgMobilityRequiresEquipmentHelp"
                v-model="value.requiresEquipmentHelp"
                :change-event="onRequiresEquipmentHelpChange"
                name="studentRequiresEquipmentHelp"
                label=""
                is-question-list
                :options="requiresEquipmentHelpOptions"
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div v-if="value.requiresEquipmentHelp" class="mt-2 mb-4">
        <validation-provider
          immediate
          v-slot="{ errors }"
          :rules="validable ? 'required' : ''"
        >
          <custom-radio
            v-model="value.studentEquipmentId"
            :change-event="onStudentEquipmentChange"
            :options="studentEquipmentOptions"
            is-inline
            class="radio-button-container"
            custom-error-msg="Favor de seleccionar una alternativa."
            :error="Boolean(errors[0])"
            :is-disabled="disabled"
          />
        </validation-provider>
      </div>

      <div class="question-element mt-2">
        <div class="item-pane color-secondary-6">
          <div class="question-line col py-3 p-0">
            <b class="mb-0">
              El estudiante es ciego total y se enfrenta a una nueva escuela o
              requiere asistencia antes de su entrenamiento en orientación y
              movilidad.
            </b>
          </div>
          <div class="align-items-end d-flex p-0 custom-radio-container">
            <validation-provider
              immediate
              v-slot="{ errors }"
              :rules="validable ? 'required' : ''"
            >
              <CustomRadioBorder
                id="rgMobilityIsBlind"
                v-model="value.isBlind"
                :change-event="onIsBlindChange"
                name="studentIsBlind"
                label=""
                is-question-list
                :options="isBlindOptions"
                class="radio-button-container"
                custom-error-msg="Favor de seleccionar Si o No."
                :error="Boolean(errors[0])"
                :disabled="disabled"
              />
            </validation-provider>
          </div>
        </div>
      </div>

      <div class="mt-4 pb-4 pr-2">
        <div>Comentarios Adicionales:</div>
        <CustomTextArea
          id="studentNeedsMobilityComments"
          v-model="value.comment"
          class="mt-2"
          :placeholder="'Escriba un comentario'"
          :maxlength="3000"
          show-char-count
          :count-classes="['d-block text-right']"
          :rows="5"
          :disabled="disabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from "@/components/pei/shared";
import CustomRadioBorder from "@/components/common/CustomRadioBorder";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";
import { getStudentEquipments } from "@/modules/common/code.api";
import studentEquipments from "@/utils/constants/student/needsEquipmentsEnum";
import CustomRadio from "custom-radio";
export default {
  name: "Mobility",
  components: {
    SectionTitle,
    CustomRadio,
    CustomRadioBorder,
    CustomTextArea,
    ActionButton
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    validable: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      hasImpedimentOptions: [
        { label: "SI", value: true, check: false },
        { label: "NO", value: false, check: false }
      ],
      isImpedimentPermanentOptions: [
        { label: "Temporero", value: false, check: false },
        { label: "Permanente", value: true, check: false }
      ],
      requiresEquipmentHelpOptions: [
        { label: "SI", value: true, check: false },
        { label: "NO", value: false, check: false }
      ],
      studentEquipmentOptions: [],
      isBlindOptions: [
        { label: "SI", value: true, check: false },
        { label: "NO", value: false, check: false }
      ]
    };
  },
  async mounted() {
    const { data } = await getStudentEquipments();
    data
      .filter(d => Object.values(studentEquipments).some(v => v === d.id))
      .forEach(equipment => {
        this.studentEquipmentOptions.push({
          label: equipment.name,
          value: equipment.id.toString(),
          check: false
        });
      });

    if (this.value.hasImpediment != null) {
      let hasImpedimentCheck = this.hasImpedimentOptions.find(
        r => r.value === this.value.hasImpediment
      );
      hasImpedimentCheck.check = true;
    }

    if (this.value.isImpedimentPermanent != null) {
      let isImpedimentPermanentCheck = this.isImpedimentPermanentOptions.find(
        r => r.value === this.value.isImpedimentPermanent
      );
      isImpedimentPermanentCheck.check = true;
    }

    if (this.value.requiresEquipmentHelp != null) {
      let requiresEquipmentHelpCheck = this.requiresEquipmentHelpOptions.find(
        r => r.value === this.value.requiresEquipmentHelp
      );
      requiresEquipmentHelpCheck.check = true;
    }

    if (this.value.studentEquipmentId != null) {
      let studentEquipmentIdCheck = this.studentEquipmentOptions.find(
        r => r.value == this.value.studentEquipmentId
      );
      studentEquipmentIdCheck.check = true;
    }

    if (this.value.isBlind != null) {
      let isBlindCheck = this.isBlindOptions.find(
        r => r.value === this.value.isBlind
      );
      isBlindCheck.check = true;
    }
  },
  methods: {
    onHasImpedimentChange(item) {
      this.$emit("input", { ...this.value, hasImpediment: item.value });
    },
    onIsImpedimentPermanentChange(item) {
      this.$emit("input", { ...this.value, isImpedimentPermanent: item.value });
    },
    onRequiresEquipmentHelpChange(item) {
      this.$emit("input", { ...this.value, requiresEquipmentHelp: item.value });
    },
    onStudentEquipmentChange(item) {
      this.$emit("input", {
        ...this.value,
        studentEquipmentId: item.value
      });
    },
    onIsBlindChange(item) {
      this.$emit("input", { ...this.value, isBlind: item.value });
    }
  }
};
</script>

<style scoped>
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.radio-button-container >>> .cr-icon {
  opacity: 1 !important;
}

.simple-radio > div > div > div.custom-control {
  display: flex;
}
</style>
